import type {AddressSuggestParams as AddressSuggestRequest, SuggestService} from '@yandex-delivery/api/service/suggest'

import type {AddressPin, PickupPointCity} from '../../model/types'
import {isUserAddressPin} from '../../utils/isUserAddressPin'
import type {FetchFunction} from '../fetch'
import {type LocationRequest, fetchDetectLocationByCity} from './fetch-detect-location'
import {toCity, toDetectCityRequest} from './mappers/toCity'

export function createCityService(params: SuggestService, fetch: FetchFunction, countryCode: string) {
  const {fetchAddressSuggest} = params

  return {
    async fetchCity(addressPin: AddressPin): Promise<PickupPointCity> {
      const location = addressPin.coordinates as LocationRequest['location']

      if (isUserAddressPin(addressPin)) {
        return fetchDetectLocationByCity(
          {
            type: 'a',
            location,
            text: addressPin.city,
          },
          fetch,
          countryCode,
        ).then(toCity)
      }

      const request: AddressSuggestRequest = {
        type: 'a',
        location,
        point: location,
        // @ts-expect-error TS2322: Type '"pin_drop"' is not assignable to type 'SuggestAction | undefined'.
        action: 'pin_drop',
      }

      return fetchAddressSuggest(request)
        .then(toDetectCityRequest(request))
        .then(req => fetchDetectLocationByCity(req, fetch, countryCode))
        .then(toCity)
    },
  }
}
